import { render, staticRenderFns } from "./ProductFunctions.vue?vue&type=template&id=1c82c70a&scoped=true&"
import script from "./ProductFunctions.vue?vue&type=script&lang=js&"
export * from "./ProductFunctions.vue?vue&type=script&lang=js&"
import style0 from "./ProductFunctions.vue?vue&type=style&index=0&id=1c82c70a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c82c70a",
  null
  
)

export default component.exports